import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './surveyBox.module.css';

const SurveyBox = React.forwardRef(({
  titleId,
  title,
  titleTag,
  clampTitle,
  icon,
  iconRowText,
  text,
  content,
  alternative
}, ref) => {
  const [showTitleTooltip, setShowTitleTooltip] = useState(false);
  const titleRef = useRef(null);
  const Title = titleTag;
  const titleStyle = clampTitle ? styles.titleLarge : styles.titleNormal;

  /* only show tooltip if title is actually clamped */
  const handleShowTooltip = () => {
    const element = titleRef.current;
    if (element && element.scrollHeight > element.clientHeight) {
      setShowTitleTooltip(true);
    }
  };

  return (
    <article ref={ref} className={[styles.container, alternative ? styles.alternative : ''].join(' ')} data-cy="survey-button-box">
      {clampTitle
        ? (
          <div
            className={styles.tooltipContainer}
            onMouseEnter={handleShowTooltip}
            onMouseLeave={() => setShowTitleTooltip(false)}
            onFocus={handleShowTooltip}
            onBlur={() => setShowTitleTooltip(false)}
            aria-describedby={showTitleTooltip ? titleId : undefined}
          >
            <Title className={titleStyle} ref={titleRef} tabIndex={0} id={titleId} aria-label={title}>{title}</Title>
            {showTitleTooltip && (
              <span
                className={styles.tooltipContent}
              >{title}
              </span>
            )}
          </div>
        ) : <Title className={titleStyle} id={titleId} tabIndex={0}>{title}</Title>}

      {icon && (
        <div className={styles.iconTextFlex}>
          {icon}
          <p className={styles.text}>{iconRowText}</p>
        </div>
      )}
      {text && <p className={styles.text}>{text}</p>}
      <section className={styles.content}>{content}</section>
    </article>
  );
});

SurveyBox.propTypes = {
  titleId: PropTypes.string,
  titleTag: PropTypes.string,
  title: PropTypes.string.isRequired,
  clampTitle: PropTypes.bool,
  icon: PropTypes.element,
  iconRowText: PropTypes.string,
  text: PropTypes.string,
  content: PropTypes.element,
  alternative: PropTypes.bool
};

SurveyBox.defaultProps = {
  titleId: null,
  titleTag: 'h3',
  clampTitle: false,
  icon: null,
  iconRowText: null,
  text: null,
  content: null,
  alternative: false
};

export default SurveyBox;
